import CustomWidgetRouteInjector from 'Store/routeInjectors/CustomWidgetRouteInjector';
import SRIRouteInjector from 'Store/routeInjectors/SRIRouteInjector';
import GeneralStyleFeedTabs from 'Style/GeneralStyleFeedTabs';
import React, {
  useEffect, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  useNavigate, useParams, useSearchParams,
} from 'react-router-dom';
import { actions as FeedActions } from 'Slice/FeedActivitiesSlice';
import { actions as helperActions } from 'Slice/HelperSlice';

import {
  newsFilter,
  selectedNewsFilter, selectedSocialFilter,
  selectAllArticles, selectedNewsArticles,
  selectedSocialArticles,
  selectNewsLoaded,
  selectCurrentSections,
} from 'Selector/FeedActivitiesSelector';

import {
  allValueInKeyOfArrayExists, anyValueInKeyOfArrayExists, getLocalStorageObject,
  certificationSmoothBehavior,
  scrollHandlerToggleClass,
  IsTablet,
  IsMobile,
  removeQueryParam,
  smoothBehavior,
  getLocalStorageValue,
  MidWidthApp1200,
} from 'Utils/UtilityFunctions';
import { Filter } from 'Types/FilterTypes';
import { FilterObject, ViewInterface } from 'Types/GlobalTypes';
import { Article } from 'Types/ArticleTypes';

import DrawerPeopleGroup from 'Components/people/components/DrawerPeopleGroup';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import {
  selectActivetype, selectHighlight, selectIsHighlighted,
  selectIsScroll, selectScrollToId, selectScrollToPage,
} from 'Selector/CertificationSelector';
import SubNavBarPrimary from 'Components/layout/headers/SubNavBarPrimary';
import classNames from 'classnames';
import ViewTabs from 'Components/common/tabs/ViewTabs';
import { isShowAskGif, selectViewTab } from 'Selector/UISelector';
import { Col, Row } from 'antd';
import { selectSalesSigmaData, selectSalesSigmaLoaded } from 'Selector/SRISelector';
import { SalesSigmaData } from 'Types/SRITypes';
import {
  selectBelts, selectLoaded, selectShowChatbot, selectShowGlobalGilroy,
} from 'Selector/GlobalSearchContentSelector';
import { NavArrayType } from 'Types/FeedActivitiesTypes';
import { FEED_ROUTE } from 'Utils/Constants';
import { Waypoint } from 'react-waypoint';
import FeedTabs from 'Components/common/tabs/Tabs';
import { useGilroy } from 'Utils/hooks/useGilroy';
import { Gilroy } from 'gilroy-global';
import FeedHighlights from 'Components/feed/components/FeedHighlights';
import Spotlight from 'Components/feed/components/Spotlight';
import DigestCustomWidget from 'Components/common/components/DigestCustomWidget';
import PulseBoard from 'Components/feed/components/PulseBoard';
import AccountActivitySection from 'Components/feed/components/AccountActivitySection';
import GlobalSearch from 'Components/globalSearch/components/GlobalSearch';
import DrawerAlerts from 'Components/alerts/components/DrawerAlerts';
import FeedStyle from 'Style/FeedStyle';
import FeedSvg from 'Components/layout/assets/FeedSvg';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import FilterPopOver from 'Components/common/components/FilterPopOver';
import OneSignal from 'Components/common/components/OneSignal';
import { actions } from '../../Slice/UISlice';
import NavBarPrimary, { chatActions, chatStates } from '../../Components/layout/headers/NavBarPrimary';

const Feed = function Feed() {
  const { saveUrl: savedUrlV2 } = chatStates;
  const { gilroyStates, gilroyActions } = useGilroy();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState<boolean>(false);
  const [isFilterChanged, setIsFilterChanged] = useState<boolean>(false);
  const selectedNewsFilters: Filter[] = useSelector(selectedNewsFilter);
  const selectedSocialFilters: Filter[] = useSelector(selectedSocialFilter);
  const [filters, setFilters] = useState<Filter[]>([]);
  const [previousNewsFiltersApplied, setPreviousNewsFiltersApplied] = useState<Filter[]>([]);
  const newsFilters: Filter[] = useSelector(newsFilter);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const allArticles: Article[] = useSelector(selectAllArticles);
  const newsArticles: Article[] = useSelector(selectedNewsArticles);
  const socialArticles: Article[] = useSelector(selectedSocialArticles);
  const [navFilterChanged, setNavFilterChanged] = useState<boolean>(false);
  const scrollToId: string = useSelector(selectScrollToId);
  const isScroll: boolean = useSelector(selectIsScroll);
  const scrollToPage: string = useSelector(selectScrollToPage);
  const tabView: ViewInterface = useSelector(selectViewTab);
  const isListView = tabView.view === 'listView';
  const getPath = getLocalStorageObject('ViewTab') as ViewInterface;
  const isMob = IsMobile();
  // const isTab = IsTablet();
  const isDesktop1200 = MidWidthApp1200();
  const [showLeaderBoard, setShowLeaderBoard] = useState(true);
  const belt = useSelector(selectBelts);
  const beltLoaded: boolean = useSelector(selectLoaded);
  const salesSigmaLoaded: boolean = useSelector(selectSalesSigmaLoaded);
  const salesSigmaData: SalesSigmaData | null = useSelector(selectSalesSigmaData);
  const personalitycolors = getLocalStorageValue('personalitycolors');
  const showAskGif = useSelector(isShowAskGif);

  // useEffect(() => {
  //   if (((salesSigmaLoaded || (beltLoaded && !belt?.id)) && !salesSigmaData?.persons.length)
  //     || (!personalitycolors || !personalitycolors.length)) {
  //     setShowLeaderBoard(false);
  //   }
  // }, [salesSigmaLoaded, salesSigmaData, belt]);

  // const collNo: boolean = (isTab || !showLeaderBoard);
  const newsLoaded = useSelector(selectNewsLoaded);

  const isHighlight = useSelector(selectHighlight);
  const currentType = useSelector(selectActivetype);
  const isHighlighted = useSelector(selectIsHighlighted);
  const chatbotAllowed = useSelector(selectShowChatbot);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const currentSections = useSelector(selectCurrentSections);
  const [searchParams] = useSearchParams();
  const [smoothScroll, setSmoothScroll] = useState(searchParams.get('scroll') || 'false');
  const [navUpdated, setNavUpdated] = useState<NavArrayType[]>([
  ]);

  const dispatch = useDispatch();
  const { section } = useParams();
  const navigate = useNavigate();

  const handleNavbar = () => {
    if (chatbotAllowed && showGlobalGilroy) {
      setNavUpdated([
        { name: 'Gilroy', isShow: true },
        { name: 'Spotlight', isShow: true },
        { name: 'News', isShow: true },
        { name: 'Social', isShow: false },
      ]);
    } else if (beltLoaded) {
      setNavUpdated([
        { name: 'Spotlight', isShow: true },
        { name: 'News', isShow: true },
        { name: 'Social', isShow: false },
      ]);
    }
  };

  useEffect(() => {
    handleNavbar();
  }, [chatbotAllowed, beltLoaded]);

  useEffect(() => {
    if (searchParams.get('notice') === 'search-cleared') {
      dispatch(helperActions.setNotification({
        message: 'Some filters expired after the page reload. Please update your search and try again.',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
      }));
      removeQueryParam('notice');
    }
  }, [searchParams]);

  useEffect(() => {
    const selected = selectedNewsFilters.map((filter) => {
      if (filter.isSelected) { return filter.filterId; }
      return null;
    });
    if (selected.length > 1) {
      setFilters(selectedNewsFilters);
      setSelectAll(allValueInKeyOfArrayExists(selectedNewsFilters, 'isSelected', true));
      setPreviousNewsFiltersApplied(selectedNewsFilters);
    } else {
      setFilters(newsFilters);
      setPreviousNewsFiltersApplied(newsFilters);
    }
    setSelectAll(allValueInKeyOfArrayExists(newsFilters, 'isSelected', true));
  }, [newsFilters, section]);

  useEffect(() => {
    if (selectedNewsFilters.length < 1 && selectedSocialFilters.length < 1) {
      let navArray = [...navUpdated];
      if (allArticles?.length) {
        navArray = navArray.map((p) => (p.name === 'Account Activity' ? { ...p, isShow: true } : p));
      }
      setNavUpdated(navArray);
    }
  }, [allArticles]);

  useEffect(() => {
    if (selectedNewsFilters.length < 1 && selectedSocialFilters.length < 1) {
      let navArray = [...navUpdated];
      if (newsArticles.length) {
        navArray = navArray.map((p) => (p.name === 'News' ? { ...p, isShow: true } : p));
      }
      setNavUpdated(navArray);
    }
  }, [newsArticles]);

  useEffect(() => {
    if (selectedNewsFilters.length < 1 && selectedSocialFilters.length < 1) {
      let navArray = [...navUpdated];
      if (socialArticles.length) {
        navArray = navArray.map((p) => (p.name === 'Social' ? { ...p, isShow: true } : p));
      }
      setNavUpdated(navArray);
    }
  }, [socialArticles]);

  const navValue = () => navUpdated.filter((n) => n.isShow).map((v) => v.name);

  const navLength = () => navUpdated.some((n) => n.isShow);

  useEffect(() => {
    if (navLength() && !section) {
      navigate(`/feed/${navUpdated[0].name.toLowerCase().trim().replace(/ /g, '')}`);
    }
  }, [navUpdated]);

  const onChangeFilters = (flag: boolean, id: string) => {
    setNavFilterChanged(true);
    const tempFilters = filters.map((filter) => {
      if (filter.filterId === id) {
        return { ...filter, isSelected: flag };
      } return filter;
    });
    setFilters(tempFilters);
    setSelectAll(allValueInKeyOfArrayExists(tempFilters, 'isSelected', true));
  };

  const selectOrUnselectAll = (flag: boolean) => {
    const tempFilters = filters.map((filter) => ({ ...filter, isSelected: flag }));
    setFilters(tempFilters);
  };

  const onClickHandler = () => {
    selectOrUnselectAll(!selectAll);
    setSelectAll(!selectAll);
  };

  const applyFilterHandler = () => {
    const params = {
      page: 1,
      filters,
    };
    dispatch(FeedActions.getNewsActivites(params));
    setNavFilterChanged(true);
    setPreviousNewsFiltersApplied(filters);
    setIsFilterChanged(true);
  };

  useEffect(() => {
    if (isFilterChanged) {
      if (anyValueInKeyOfArrayExists(filters, 'isSelected', false)) {
        setIsFilterActive(true);
      } else {
        setIsFilterActive(false);
      }
      setIsFilterChanged(false);
    }
  }, [isFilterChanged]);

  const checkForApplyFilter = () => {
    for (let i = 0; i < filters.length; i += 1) {
      if (filters[i].isSelected !== previousNewsFiltersApplied[i]?.isSelected) return false;
    }
    return true;
  };

  const handleFilters = (obj: FilterObject) => {
    const { filters: navFilters, selectAll: navSelectAll } = obj;
    setFilters(navFilters);
    setSelectAll(navSelectAll);
  };

  const handleFilterChanged = () => {
    setNavFilterChanged(false);
  };

  const toggle = (flag: boolean) => {
    setOpenCreateModal(flag);
  };

  useEffect(() => {
    if (isScroll && scrollToPage.includes(FEED_ROUTE) && newsLoaded) {
      certificationSmoothBehavior(scrollToId);
      dispatch(certificationActions.setIsScroll(false));
    }
  }, [scrollToId, isScroll, newsLoaded]);

  useEffect(() => {
    scrollHandlerToggleClass('.sub-header-main-wrapper', 'isSticky', false);
  });

  useEffect(() => {
    dispatch(actions.isTabView({
      view: getPath.view,
    }));
  }, [getPath.view]);

  useEffect(() => {
    if (!isHighlighted && !isScroll && (currentType === 'pulse_filter' || currentType === 'account_sales_tab')) {
      dispatch(certificationActions.setHighlight(true));
      dispatch(certificationActions.setIsHighlighted(false));
    }
  }, [isScroll, currentType]);
  useEffect(() => {
    if (smoothScroll === 'true') {
      removeQueryParam('scroll');
    }
    if (smoothScroll === 'true' && newsLoaded) {
      smoothBehavior();
      setSmoothScroll('false');
    }
    return () => { setSmoothScroll('false'); };
  }, [newsLoaded, smoothScroll]);

  useEffect(() => {
    if (window.location.href !== savedUrlV2) {
      dispatch(actions.isShowGilroyGlobalToggle(false));
      chatActions.setShowLibrary(true);
      chatActions.setShowExamplePrompts(false);
      chatActions.resetChatHistory();
      chatActions.setSelectedConversationId(-1);
      handleNavbar();
    }
    if (window.location.href === savedUrlV2) {
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
      handleNavbar();
    }
  }, []);

  const tabToHighlight = () => {
    if (currentSections.length === 1) {
      return currentSections[0];
    }
    if (currentSections.length === 2 && currentSections.includes('Gilroy') && currentSections.includes('News')) {
      return 'Gilroy';
    }
    if (currentSections.length === 2 && currentSections.includes('Gilroy') && currentSections.includes('Spotlight')) {
      return 'Gilroy';
    }
    if (currentSections.length === 2 && currentSections.includes('Spotlight') && currentSections.includes('News')) {
      return 'News';
    }
    return 'Gilroy';
  };

  const salesTriggerHeaderActions = (
    <>
      <div className={classNames('view-tabs', { notdisabledTabs: newsLoaded })}>
        <ViewTabs
          disabled={!newsLoaded}
          listView={isListView}
        />
      </div>
      <div className={classNames('filter-placeholder', {
        disabledFilter: !newsLoaded || filters.length === 0,
      })}
      >
        <FilterPopOver
          loading={false}
          filters={filters}
          selectAll={selectAll}
          onChangeFilters={onChangeFilters}
          onClickHandler={onClickHandler}
          applyFilterHandler={applyFilterHandler}
          disableApplyBtn={checkForApplyFilter()}
          iconMode={IsTablet()}
          isActive={isFilterActive}
          showContent
        />
      </div>
    </>
  );

  return (
    <>
      <OneSignal />
      <FeedStyle />
      <NavBarPrimary headerClassName="no-overflow-on-header">
        <div className="left-side-wrap">
          <FeedSvg />
          <h1 className="heading">The Feed</h1>
        </div>
        <div className="right-side-wrap">
          <GlobalSearch iconMode={IsTablet()} />
          <DrawerAlerts />
          <AccountPopOver />
        </div>
      </NavBarPrimary>
      <SubNavBarPrimary>
        <div className="heading-inner-page tabs-placeholder wrap-slider hidden-scroll feed-page-tabs">
          <div className="head-wrap" />
          <div className="tips-placeholder">
            <FeedTabs
              baseComponentPath="feed"
              tabsName={navValue()}
              headerAppendTab
              elementTarget="tabs-details"
              fromFeedTab
              feedActiveTab={tabToHighlight()}
            />
          </div>
        </div>

      </SubNavBarPrimary>
      <div className={classNames('container feed-container', { hideBrowserDrawerScroll: showAskGif })}>
        {chatbotAllowed && showGlobalGilroy ? (
          <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} isGilroyV2 />
        ) : null}

        <Waypoint onEnter={() => dispatch(FeedActions.pushCurrentSection('Spotlight'))} onLeave={() => dispatch(FeedActions.removeCurrentSection('Spotlight'))}>
          <div id="certification-spotlight" className="feed-spotlight-section">
            <Spotlight listview={isListView} />
            <DigestCustomWidget />
            <Row gutter={16} className="pulse-leader-div">
              <Col span={isMob || isDesktop1200 ? 24 : 8}>
                <div
                  id="certification-pulse"
                  className={classNames('h-100', { highlightedComponent: isHighlight && currentType === 'pulse_filter' }, { subComponentOverlayWhite: isHighlight && currentType === 'pulse_filter' })}
                >
                  <PulseBoard withoutLeaderBoard={false} />
                </div>
              </Col>
              <Col span={isMob || isDesktop1200 ? 24 : 16}>
                <FeedHighlights />
              </Col>
            </Row>
          </div>
        </Waypoint>

        <Waypoint onEnter={() => dispatch(FeedActions.pushCurrentSection('News'))} onLeave={() => dispatch(FeedActions.removeCurrentSection('News'))} bottomOffset="60%">
          <div
            id="certification-feed-tabs"
            className={classNames(
              { highlightedComponent: isHighlight && currentType === 'account_sales_tab' },
              { subComponentOverlayWhite: isHighlight && currentType === 'account_sales_tab' },
            )}
          >
            <AccountActivitySection
              filterChanged={navFilterChanged}
              onFilterChanged={handleFilterChanged}
              filters={filters}
              selectAll={selectAll}
              onChangeGetFilters={handleFilters}
              navUpdated={navUpdated}
              listView={isListView}
              headerActions={salesTriggerHeaderActions}
            />
          </div>
        </Waypoint>
        <DrawerPeopleGroup
          openNewCreate={openCreateModal}
          setOpenNew={toggle}
          showNew={showNew}
          toggleShowNew={(bool: boolean) => setShowNew(bool)}
          disableDrop
          noButton
        />
      </div >
    </>
  );
};

export default Feed;
